import React, { useState } from 'react';
import Box from '@material-ui/core/Box';
import TextField from '@material-ui/core/TextField';
import AccountCircle from '@material-ui/icons/AccountCircle';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import Button from '@material-ui/core/Button';
import InputAdornment from '@material-ui/core/InputAdornment';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import IconButton from '@material-ui/core/IconButton';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { useForm } from 'react-hook-form';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { useAuth } from 'components/AuthProvider';

interface Props {}

interface Inputs {
  email: string;
  password: string;
}

const useStyles = makeStyles((theme: Theme) => ({
  form: { width: 240, margin: 'auto' },
  backdrop: { zIndex: theme.zIndex.drawer + 1, color: '#fff' },
  error: { paddingBottom: '10%' },
}));

const LoginForm = (props: Props) => {
  const classes = useStyles();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const { register, handleSubmit } = useForm<Inputs>();
  const [showPassword, setShowPassword] = useState(false);
  const handleShowPassword = () => setShowPassword(!showPassword);

  const { login } = useAuth();
  const onSubmit = ({ email, password }: Inputs) => {
    setLoading(true);
    login(email, password).catch((error: string) => {
      console.error(error);
      setError(error);
      setLoading(false);
    });
  };

  const onErrorClose = () => setError(null);

  return (
    <>
      <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
        <Box
          display="grid"
          justifyContent="center"
          alignItems="center"
          gridRowGap={20}
          gridColumnGap={20}
        >
          <TextField
            name="email"
            type="email"
            autoComplete="email"
            required
            label="ユーザ名"
            variant="standard"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <AccountCircle />
                </InputAdornment>
              ),
            }}
            inputRef={register({ required: true })}
          />
          <TextField
            name="password"
            variant="standard"
            label="パスワード"
            type={showPassword ? 'text' : 'password'}
            autoComplete="current-password"
            required
            inputRef={register({ required: true })}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <VpnKeyIcon />
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleShowPassword}
                  >
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <Box margin="auto">
            <Button
              type="submit"
              variant="contained"
              color="primary"
              endIcon={<ExitToAppIcon />}
              disabled={loading}
            >
              ログイン
            </Button>
          </Box>
        </Box>
      </form>
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress />
      </Backdrop>
      <Snackbar
        open={!!error}
        autoHideDuration={6000}
        onClose={onErrorClose}
        className={classes.error}
        anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
      >
        <Alert severity="error" onClose={onErrorClose}>
          {error}
        </Alert>
      </Snackbar>
    </>
  );
};

export default LoginForm;
